import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
	import { Facebook_APP_ID } from "@/.config";
	import { WindowsFilled } from "@ant-design/icons-vue";

	declare global {
		interface Window {
			FB: any;
			google: any;
			AppleID: any; //
		}
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	onMounted(() => {
		if (window.FB) {
			window.FB.init({
				appId: Facebook_APP_ID,
				status: true,
				cookie: true,
				xfbml: true,
				version: "v10.0",
			});
		} else {
			console.error("Facebook SDK not loaded");
		}
	});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    style: {"min-height":"100vh"},
    theme: {
			token: {
				colorPrimary: '#44142a',
				colorPrimaryBg: '#fcdfec',
			},
		}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})